import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';
import { UIWorkFieldModel, UIPropertyModel } from 'e5core-angular-services';

@Component({
  selector: 'e5core-ui-work-field-switch',
  templateUrl: './e5core-ui-work-field-switch.component.html'
})
export class E5coreUiWorkFieldSwitchComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() field: UIWorkFieldModel ;
  @Input() property: UIPropertyModel ;
  @Input() readonly: boolean;

  RegexGuid = '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$' ;
  RegexCurrency = '^\\$?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$';
  RegexDecimal = '^\\d*\\.?\\d*$';

  constructor() { }

  ngOnInit() {
  }

}
